import type { V2CurrentPositionRow } from '@gpx-spa/queries/src/getAccountCurrentPositionsV2';
import type { LatLng } from '@/components/shipment/form/utils/build-routing-coordinates';

export function currentPositionToLatLng(
  row: V2CurrentPositionRow | null | undefined,
): LatLng | null {
  const loc = row?.location;
  if (!loc || loc.length < 2) return null;
  const [lng, lat] = loc;
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return { lat, lng };
}
